import VpExternalLinkIcon from '@vtmn-play/icons/react/VpExternalLinkIcon';
import VpBarChartIcon from '@vtmn-play/icons/react/VpBarChartIcon';
import VpShoppingBagIcon from '@vtmn-play/icons/react/VpShoppingBagIcon';
import VpTruckIcon from '@vtmn-play/icons/react/VpTruckIcon';
import VpToolsIcon from '@vtmn-play/icons/react/VpToolsIcon';
import VpCalendarIcon from '@vtmn-play/icons/react/VpCalendarIcon';
import VpUserIcon from '@vtmn-play/icons/react/VpUserIcon';
import VpHomeIcon from '@vtmn-play/icons/react/VpHomeIcon';
import VpSettingsIcon from '@vtmn-play/icons/react/VpSettingsIcon';

import { useSelectFeatureSettings, useSelectIsRW } from '../../apis/startup/startup.selectors';
import { useDataStudio } from '../../utils/hooks/useDataStudio';
import { DEFAULT_ACTIVE_TAB } from '../../pages/SparePartOrders/constants';
import { RoutesPath, getAppRoute } from '../../core/routes';

export const useNavigationLinks = () => {
  const isBookingsEnabled = useSelectFeatureSettings('bookings');
  const hasRWRelatedStores = useSelectIsRW();
  const dataStudioLink = useDataStudio();

  return [
    {
      label: 'home',
      route: getAppRoute(RoutesPath.homePage),
      icon: VpHomeIcon,
      exactPath: true,
      enabled: true,
      externalLink: false,
      dataTestId: 'button-home',
      event: 'home',
      isNew: false,
    },
    {
      label: 'bookings',
      route: getAppRoute(RoutesPath.bookingsPage),
      icon: VpUserIcon,
      enabled: isBookingsEnabled,
      externalLink: false,
      dataTestId: 'button-bookings',
      event: 'bookings',
      isNew: false,
    },
    {
      label: 'planning',
      route: getAppRoute(RoutesPath.planningPage),
      icon: VpCalendarIcon,
      exactPath: false,
      enabled: true,
      externalLink: false,
      dataTestId: 'button-planning',
      event: 'planning',
      isNew: false,
    },
    {
      label: 'interventions',
      route: getAppRoute(RoutesPath.searchPage),
      icon: VpToolsIcon,
      exactPath: false,
      enabled: true,
      externalLink: false,
      dataTestId: 'button-interventions',
      event: 'interventions',
      isNew: false,
    },
    {
      label: 'parcels.flow',
      route: getAppRoute(RoutesPath.shippingPage),
      icon: VpTruckIcon,
      exactPath: false,
      enabled: true,
      externalLink: false,
      dataTestId: 'button-shipping',
      event: 'shipping',
      isNew: false,
    },
    {
      label: 'order',
      route: { pathname: getAppRoute(RoutesPath.sparePartOrders), search: `?activeTab=${DEFAULT_ACTIVE_TAB}` },
      icon: VpShoppingBagIcon,
      exactPath: true,
      enabled: true,
      externalLink: false,
      dataTestId: 'button-order',
      event: 'order',
      isNew: false,
    },
    {
      label: 'dashboard.report',
      route: dataStudioLink,
      icon: VpBarChartIcon,
      enabled: true,
      externalLink: true,
      dataTestId: 'button-report',
      event: 'report',
      isNew: false,
    },
    {
      label: 'useful.links',
      route: getAppRoute(RoutesPath.usefulLinksPage),
      icon: VpExternalLinkIcon,
      enabled: true,
      externalLink: false,
      dataTestId: 'button-useful-links',
      event: 'external_links',
      isNew: false,
    },
    {
      label: 'parameters',
      route: getAppRoute(RoutesPath.delayParamPage),
      icon: VpSettingsIcon,
      enabled: hasRWRelatedStores,
      externalLink: false,
      dataTestId: 'button-settings',
      event: 'delays_parameters',
      isNew: false,
    },
  ] as const;
};
